import React, { FC, useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import './confirm-dialog.less';
import BaseModal from '../base/BaseModal';
import { SvgIcon, Button } from '@/components';
const ConfirmDialog: FC<ModalFuncProps> = ({
  type = 'success',
  icon = '',
  className = 'confirm-dialog-wrapper',
  title = '保存成功！',
  style = {},
  content = '',
  sureContent = '',
  afterClose = () => {},
}) => {
  const [visible, setVisible] = useState<boolean>(true);
  useEffect(() => {
    if (!visible) {
      afterClose();
    }
  }, [visible, afterClose]);
  return (
    <BaseModal className={`${className}`} visible={visible} style={style}>
      <div className="icon tc">
        {icon ? (
          icon
        ) : (
          <>
            {type === 'success' ? (
              <SvgIcon name={'success'} style={{ fill: '#00b860' }} />
            ) : null}
            {type === 'error' ? (
              <SvgIcon name={'error'} style={{ fill: '#DE0000' }} />
            ) : null}
          </>
        )}
      </div>
      <div className="tit">{title}</div>
      <div className="content flex1">{content}</div>
      <Button
        className="dbi w100"
        type={type}
        onClick={() => {
          setVisible(false);
        }}
      >
        {sureContent || '确认'}
      </Button>
    </BaseModal>
  );
};
export interface ModalFuncProps {
  icon?: React.ReactElement;
  className?: string;
  title?: React.ReactNode;
  content?: React.ReactNode;
  sureContent?: React.ReactNode;
  onOk?: (...args: any[]) => any;
  afterClose?: () => void;
  style?: React.CSSProperties;
  type?: 'success' | 'error';
}

export default function confirm(config: ModalFuncProps) {
  const div = document.createElement('div');
  function render(props: any) {
    setTimeout(() => {
      ReactDOM.render(<ConfirmDialog {...props} />, div);
    });
  }
  render(config);
}
